export async function getMerkzettelIds() {
    if (SiteInfo.accessToken === "") {
        return await fetchGuestRemindedAdvertIds()
    }
    return siteConfig.merkzettelIds || []
}

export function createMerkzettelStarIcon() {
    const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg")
    svgElement.classList.add("card-merkzettel-star")
    svgElement.innerHTML = `<path d="M2.975 14.803l1.553-4.865-4.018-2.84c-0.177-0.124-0.219-0.368-0.095-0.545 0.076-0.108 0.197-0.165 0.32-0.165v-0.001h5.039l1.848-5.455c0.069-0.204 0.291-0.314 0.496-0.245 0.119 0.040 0.205 0.133 0.243 0.244l0.001-0 1.882 5.456h5.022c0.216 0 0.391 0.175 0.391 0.391 0 0.142-0.077 0.267-0.19 0.336l-3.977 2.822 1.546 4.887c0.065 0.206-0.049 0.426-0.255 0.491-0.128 0.040-0.262 0.012-0.36-0.065l-4.428-2.818-4.442 2.839c-0.181 0.116-0.423 0.062-0.538-0.119-0.069-0.108-0.079-0.237-0.036-0.349z"/>`
    return svgElement
}

export async function fetchGuestRemindedAdvertIds() {
    if (SiteInfo.accessToken === "") {
        if (getCookie(SiteInfo.reminderHasUpdateCookie) !== null) {
            const response = await fetch(`${SiteInfo.yiiLadiesUrl}/merkzettel/ajaxCheckIfUpdated`, {
                method: "GET",
                mode: "cors",
                credentials: "include",
            })

            const data = await response.json()
            return JSON.parse(data.remindedAdvertList)
        }

        return getCookie(SiteInfo.guestAdvertListCookie) || []
    }
}

export function getCookie(name: string): string | null {
    const nameLenPlus = name.length + 1
    return (
        document.cookie
            .split(";")
            .map((c) => c.trim())
            .filter((cookie) => {
                return cookie.substring(0, nameLenPlus) === `${name}=`
            })
            .map((cookie) => {
                return decodeURIComponent(cookie.substring(nameLenPlus))
            })[0] || null
    )
}
